export default "__VITE_ASSET__DbpsyqOz__"